import React, { useState, useEffect } from "react";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md"; // Import the arrow down and up icons
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie'; // Import js-cookie library
import { zb_password } from '../../App';
import { parlament_password } from '../../App';

import "./Navbarstyle.css";

function Navbar() {
  const [nav, setNav] = useState(false);
  const [zeltPassword, setZeltPassword] = useState(Cookies.get('zbpasswordentered') === 'true');
  const [parlamentPassword, setParlamentPassword] = useState(Cookies.get('ppasswordentered') === 'true');
  const [bereich, setBereich] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  const [isHomePage, setIsHomePage] = useState(location.pathname === "/home");

  useEffect(() => {
    setIsHomePage(location.pathname === "/home");
    const bereichCookie = Cookies.get('Bereich');
    setBereich(bereichCookie || ''); // Set the Bereich from cookies
    // Dependency auf das ganze location-Objekt (nicht nur pathname): bei
    // navigate("/home") von /home aus ändert sich der location.key, und der
    // Bereich wird auch dann frisch aus dem Cookie gelesen.
  }, [location]);

  useEffect(() => {
    const body = document.body;
    body.classList.remove('Zeltbetreuung', 'Arbeit-Freizeit', 'Parlament', 'Logistik');
    if (bereich) {
      body.classList.add(bereich.replace(/[^a-zA-Z0-9]/g, '-'));
    }
  }, [bereich]);
  
  const handleNav = () => setNav(!nav);

  // React-Navigation statt window.location.href: kein Vollreload — auf dem
  // Camp-WLAN spürbar schneller. Der Bereich wird über Cookie + location-Effect
  // synchron gehalten.
  const handleNavItemClick = (cookieValue, bereich) => {
    setNav(false);
    Cookies.set('Team', cookieValue);
    if (bereich) {
      Cookies.set('Bereich', bereich);
      setBereich(bereich); // Update the selected Bereich
    }
    navigate("/home");
  };

  const handleZeltbetreuungClick = () => {
    if (zeltPassword) {
      handleNavItemClick('ZB', 'Zeltbetreuung');
      return;
    }
    const password = prompt("Bitte gib das Passwort ein:");
    if (password === `${zb_password}`) {
      setZeltPassword(true);
      Cookies.set('zbpasswordentered', 'true', { expires: 10 }); // Login 10 Tage speichern
      handleNavItemClick('ZB', 'Zeltbetreuung');
    } else {
      alert("Falsches Passwort!");
    }
  };

  const handleParlamentClick = () => {
    if (parlamentPassword) {
      handleNavItemClick('P', 'Parlament');
      return;
    }
    const password = prompt("Bitte gib das Passwort ein:");
    if (password === `${parlament_password}`) {
      setParlamentPassword(true);
      Cookies.set('ppasswordentered', 'true', { expires: 10 }); // Login 10 Tage speichern
      handleNavItemClick('P', 'Parlament');
    } else {
      alert("Falsches Passwort!");
    }
  };
    
  return (
    <div className="navbar">
        {/* <div className={`logo ${isHomePage ? 'hide-back-arrow' : ''}`} onClick={handleBackClick}>
          <MdOutlineArrowBackIos />
        </div> */}
        <div className="navbar-left">
          <div className="logo" onClick={() => navigate("/home")}>
            <span className="logo-text">Start</span>
          </div>
        </div>
        {!(location.pathname === '/' && !bereich) && (
          <div className="dropdown-container">
              <div className="logo" onClick={handleNav}>
                  <span className="logo-text">{bereich || "Bereich wählen"}</span> {nav ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
              </div>
              <div className={nav ? 'mobile-menu active' : 'mobile-menu'}>
                  <ul className="mobile-nav">
                      <Link
                          to="/home"
                          className={`li ${bereich === 'Zeltbetreuung' ? 'active-item' : ''}`}
                          onClick={handleZeltbetreuungClick}
                      >
                          Zeltbetreuung
                      </Link>
                      <Link
                          to="/home"
                          className={`li ${bereich === 'Arbeit/Freizeit' ? 'active-item' : ''}`}
                          onClick={() => handleNavItemClick('AF', 'Arbeit/Freizeit')}
                      >
                          Arbeit/Freizeit
                      </Link>
                      <Link
                          to="/home"
                          className={`li ${bereich === 'Parlament' ? 'active-item' : ''}`}
                          onClick={handleParlamentClick}
                      >
                          Parlament
                      </Link>
                      <Link
                          to="/home"
                          className={`li ${bereich === 'Logistik' ? 'active-item' : ''}`}
                          onClick={() => handleNavItemClick('L', 'Logistik')}
                      >
                          Logistik
                      </Link>
                  </ul>
              </div>
          </div>
        )}
        <div className="navbar-right">
          <div className="logo" onClick={() => navigate("/tagesablauf")}>
            <span className="material-symbols-outlined map-icon">schedule</span>
          </div>
          <div className="logo" onClick={() => navigate("/speiseplan")}>
            <span className="material-symbols-outlined map-icon">flatware</span>
          </div>
          <div className="logo" onClick={() => navigate("/stadtplan")}>
            <span className="material-symbols-outlined map-icon">map</span>
          </div>
        </div>
    </div>
  );
}

export default Navbar;
